import { useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import devLogger from 'react-utils/devLogger';
import Raven from 'raven-js';
import { DuplicateIcon } from 'foundations-assets/icons/components/DuplicateIcon';
import { CopyButton } from 'foundations-components/transitional/components/CopyButton';
import { Box } from 'foundations-components/transitional/components/Box';
import { SecondaryPropertyDisplay } from './SecondaryPropertyDisplay';
import { jsx as _jsx } from "react/jsx-runtime";
const isValidCopyValue = copyValue => {
  const copyValueType = typeof copyValue;
  const isCopiable = copyValueType === 'string' || copyValueType === 'number';
  if (!isCopiable) {
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '{ message: string; }' is not ass... Remove this comment to see the full error message
    devLogger.warn({
      message: '[UniversalSidebar]: CopyValue for Property copy must be of type string or number.'
    });
    Raven.captureMessage(`UniversalSidebar: invalid propType for copyValue: found ${copyValueType} but expected string or number`, {
      extra: {
        copyValue,
        copyValueType
      }
    });
    return false;
  }
  return true;
};
const PropertyCopy = ({
  data,
  copyValue,
  onClick = () => {},
  propertyName,
  isCopyDisabled,
  propertyLabel
}) => {
  const ref = useRef(null);
  const canCopy = !isCopyDisabled && (!copyValue || isValidCopyValue(copyValue));
  const valueWhenCopied = useCallback(() => copyValue || ref.current && ref.current.innerText || '', [copyValue]);
  const CopyButtonComponent = canCopy ? /*#__PURE__*/_jsx(Box, {
    shrink: 0,
    alignSelf: "center",
    marginInlineStart: "200",
    children: /*#__PURE__*/_jsx(CopyButton, {
      responsive: false,
      use: "link",
      onClick: onClick,
      "data-selenium-test": `property-copy-button-${propertyName}`,
      "data-test-id": `property-copy-button-${propertyName}`,
      valueWhenCopied: valueWhenCopied,
      children: /*#__PURE__*/_jsx(DuplicateIcon, {
        size: "100"
      })
    })
  }) : null;
  return /*#__PURE__*/_jsx(SecondaryPropertyDisplay, {
    propertyValue: data,
    propertyLabel: propertyLabel,
    copyButtonComponent: CopyButtonComponent,
    ref: ref
  });
};
PropertyCopy.propTypes = {
  copyValue: PropTypes.string,
  data: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  propertyName: PropTypes.string.isRequired,
  isCopyDisabled: PropTypes.bool,
  propertyLabel: PropTypes.string
};
export default PropertyCopy;